<script>
	import { format_money_$_with_optional_cents } from 'shared/format_currency'

	export let item

	// changes of only one cent are probably floating point errors
	const further_apart_than_one_cent = (a, b) => Math.abs(a - b) > 0.01

	const cents_to_formatted_dollars = v => format_money_$_with_optional_cents(v / 100)
</script>

<div class="prices">
	{#if item.prices.default.qty > 0 && item.product.type !== `donation` && item.product.type !== `trex_gift_card`}
		<div>
			<div class="price">
				{#if further_apart_than_one_cent(item.inferred_unit_price, item.product.regular_price)}<del>{ cents_to_formatted_dollars(item.product.regular_price) }</del>{/if}
				<ins>{ cents_to_formatted_dollars(item.inferred_unit_price) }</ins>
			</div>
			{#if Object.keys(item.prices.combos).length > 0 }<div class="qty">&times; { item.prices.default.qty }</div>{/if}
		</div>
	{/if}

	{#each Object.entries(item.prices.combos) as [ price, qty ] }
		{#if qty > 0}
			<div class="combo">
				<div class="texto">Combo</div>
				<div class="price">
					{#if further_apart_than_one_cent(price, item.prices.default.price) }<del>{ cents_to_formatted_dollars(item.prices.default.price) }</del>{/if}
					<ins>{ cents_to_formatted_dollars(price) }</ins>
				</div>
				{#if item.prices.default.qty > 0 || Object.keys(item.prices.combos).length > 1 }<div class="qty">&times; { qty }</div>{/if}
			</div>
		{/if}
	{/each}
</div>

<style>
	.prices {
		padding-left: 10px;
	}

	.combo {
		padding: 3.5px 8px;
		border: 1px solid #ff8924;
		border-radius: 3px;
	}

	.texto {
		display: inline-block;
		vertical-align: middle;
		text-transform: uppercase;
		font-size: 10px;
		color: #ff8924;
		margin-right: 5px;
	}

	@media (max-width: 600px) {
		.combo {
			padding: 2px 5px;
		}

		.texto {
			font-size: 8px;
			margin-right: 2px;
		}
	}

	.prices .price {
		line-height: 1;
		color: #fff;
		flex: 1;
		vertical-align: baseline;
	}

	@media (max-width: 600px) {
		.prices .price {
			font-size: 110%;
		}
	}

	.prices .price del {
		font-size: 90%;
		opacity: .5;
	}

	@media (max-width: 500px) {
		.prices .price del {
			display: block;
			text-align: right;
			padding-bottom: 2px;
		}
	}

	.prices .price ins {
		text-decoration: none;
	}

	.prices .qty {
		font-size: 90%;
		padding-left: 4px;
		vertical-align: baseline;
	}

	@media (max-width: 600px) {
		.prices .qty {
			padding-left: 2px;
		}
	}
</style>
